<template>
  <Content class="pro-content">
    <Card class="content-wrapper" dis-hover>
      <img src="../assets/sherbimet21_9.jpg" loading="lazy" />
      <Row class="company-services" type="flex" style="padding: 15px 7px" :gutter="15">
        <i-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" :xxl="18">
          <Card icon="md-cash" dis-hover>
            <h1 slot="title">
              <Icon type="md-cash" :style="{ 'vertical-align': 'text-bottom' }" />
              {{ $t("loans") }}
            </h1>
            <Row :gutter="24">
              <i-col :md="8">
                <Menu :theme="'light'" width="auto" :active-name="$route.path">
                  <Submenu :name="$t('individual')" style="width: 100%">
                    <template slot="title">
                      <Icon type="ios-person-outline" :size="21" />{{ $t("individual") }}
                    </template>
                    <MenuItem name="/services/individual/cash" to="/services/individual/cash">
                      <Icon type="ios-cash-outline" :size="20" />
                      {{ $t("cash_loan.menu_title") }}
                    </MenuItem>
                    <MenuItem name="/services/individual/renovation" to="/services/individual/renovation">
                      <Icon type="ios-home-outline" :size="20" />
                      {{ $t("renovation_loan.menu_title") }}
                    </MenuItem>
                    <MenuItem name="/services/individual/cars" to="/services/individual/cars">
                      <Icon type="ios-car-outline" :size="20" />
                      {{ $t("car_loan.menu_title") }}
                    </MenuItem>
                    <MenuItem name="/services/individual/mortgage" to="/services/individual/mortgage">
                      <Icon type="ios-card-outline" :size="20" />
                      {{ $t("mortgage_loan.menu_title") }}
                    </MenuItem>
                    <MenuItem name="/services/individual/other" to="/services/individual/other">
                      <Icon type="ios-apps-outline" :size="20" />
                      {{ $t("other_loans.menu_title") }}
                    </MenuItem>
                  </Submenu>
                  <Submenu :name="$t('business')" style="width: 100%">
                    <template slot="title"> <Icon type="ios-briefcase" :size="20" />{{ $t("business") }} </template>
                    <MenuItem name="/services/business/goods-financing" to="/services/business/goods-financing">
                      <Icon type="ios-water-outline" :size="20" />
                      {{ $t("goods_financing.menu_title") }}
                    </MenuItem>
                    <MenuItem name="/services/business/assets-financing" to="/services/business/assets-financing">
                      <Icon type="ios-stats-outline" :size="20" />
                      {{ $t("assets_financing.menu_title") }}
                    </MenuItem>
                    <MenuItem name="/services/business/mortgage-financing" to="/services/business/mortgage-financing">
                      <Icon type="logo-euro" :size="20" />
                      {{ $t("mortgage_financing.menu_title") }}
                    </MenuItem>
                    <MenuItem name="/services/business/other" to="/services/business/other">
                      <Icon type="ios-apps-outline" :size="20" />
                      {{ $t("other_finances.menu_title") }}
                    </MenuItem>
                  </Submenu>
                  <Submenu :name="$t('list_of_documents')" style="width: 100%">
                    <template slot="title">
                      <Icon type="ios-document" :size="21" />{{ $t("list_of_documents") }}
                    </template>
                    <MenuItem name="/services/documents/individual" to="/services/documents/individual">
                      <Icon type="ios-document-outline" :size="20" />{{ $t("individual_loan_docs") }}
                    </MenuItem>
                    <MenuItem name="/services/documents/business" to="/services/documents/business">
                      <Icon type="ios-document-outline" :size="20" />{{ $t("business_loan_docs") }}
                    </MenuItem>
                    <MenuItem
                      name="/services/documents/individual-business"
                      to="/services/documents/individual-business"
                    >
                      <Icon type="ios-document-outline" :size="20" />{{ $t("individual_business_loan_docs") }}
                    </MenuItem>
                  </Submenu>
                </Menu>
              </i-col>
              <i-col :md="16">
                <div class="text-services">
                  <h3>{{ $t("all_services.title") }}</h3>
                  <br />
                  <p>{{ $t("all_services.description") }}</p>
                </div>
              </i-col>
            </Row>
          </Card>
        </i-col>

        <i-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" :xxl="6" class="news-col">
          <Row class="latest-news" :type="'flex'">
            <i-col>
              <h1>{{ $t("news") }}</h1>
              <router-link to="/news">
                <Icon type="md-paper"></Icon>
                <span>
                  {{ $t("all_news") }}
                  <Icon type="ios-arrow-forward" />
                </span>
              </router-link>
            </i-col>
          </Row>
          <Row class="news-row">
            <i-col>
              <!-- Loading -->
              <div v-if="$apollo.queries.Banknews.loading" class="loading apollo">
                <i-col class="spin-col" span="24" style="min-width: 100%">
                  <Spin fix>
                    <Icon type="ios-loading" size="18" class="icon-load"></Icon>
                    <div>{{ $t("loading") }}</div>
                  </Spin>
                </i-col>
              </div>

              <!-- Error -->
              <div v-else-if="bankNewsQuery && bankNewsQuery.error" class="error apollo">{{ $t("error") }}</div>

              <!-- Result -->

              <template v-else-if="bankNews">
                <news-item
                  v-for="(item, index) in bankNews && bankNews.slice(0, 3)"
                  :key="index"
                  :fullsize="true"
                  :title="item.title"
                  :title_al="item.title_al"
                  :src="item.image && item.image.url"
                  :description="item.description"
                  :description_al="item.description_al"
                  :id="item.id"
                  style="padding-left: 7.5px; padding-right: 7.5px"
                />
              </template>

              <!-- No result -->
              <div v-else class="no-result apollo">{{ $t("no_result") }}</div>
            </i-col>
          </Row>
        </i-col>
      </Row>
    </Card>
  </Content>
</template>

<script>
import NewsItem from '../components/NewsItem.vue';
import BankNewsQuery from '../graphql/News.gql';

export default {
  name: 'home',
  components: {
    NewsItem,
  },
  methods: {
    renderByI18n(item, property) {
      if (this._i18n.locale === 'en') {
        return item[property];
      }
      return item[`${property}_al`];
    },
    renderOnly30Chars(theString) {
      return `${theString.slice(0, 100)}...`;
    },
  },
  data() {
    return {
      value1: 0,
      typesOfLoans: ['individual', 'enterprise', 'agricultural', 'residence'],
      bankNews: [],
      bankNewsQuery: {},
    };
  },
  apollo: {
    Banknews: {
      query: BankNewsQuery,
      variables: () => ({ $sort: 'createdAt:ASC' }),
      result(response) {
        console.warn(response);

        this.bankNewsQuery = response;

        const bankNews = this.bankNewsQuery && this.bankNewsQuery.data.banknews && this.bankNewsQuery.data.banknews.data.length
          ? this.bankNewsQuery.data.banknews.data
          : [];

        const mappedBankNews = bankNews.map((item) => {
          const img = item.attributes.image && item.attributes.image.data && item.attributes.image.data.attributes;
          return {
            ...item,
            ...item.attributes,
            image: { url: img && img.url ? `${process.env.VUE_APP_STRAPI}${img.url}` : null },
          };
        });

        this.bankNews = mappedBankNews;
      },
      update({ banknews }) {
        return banknews;
      },
    },
  },
};
</script>

<style lang="scss">
.latest-news {
  background-color: #10a995;
  padding: 15px;
  border-radius: 4px 4px 0px 0px;
  color: white;
  a {
    color: white;
    font-size: 15px;
    span {
      font-size: 15px;
      margin-left: 3px;
    }
    i {
      font-size: 15px;
      vertical-align: text-bottom;
    }
  }
}
.news-row {
  background-color: white;
  border-radius: 0px 0px 4px 4px;
  padding: 8px 0;
  .spin-col {
    margin: 0 8px;
    min-width: calc(100% - 15px) !important;
    max-width: calc(100% - 15px) !important;
  }
}
.carousel {
  img {
    object-fit: contain;
    background-color: #e3e5e8;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
  height: 500px;
  display: flex;
  position: relative;
  .text-wrapper {
    line-height: 1;
    color: black;
    background-color: rgba(0, 0, 0, 0.33);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    // width: 100%;
    height: 100%;
    color: white;
    .text {
      padding: 50px;
      // background-color: rgba(23, 35, 61, 0.5019607843137255);
      color: white;
      white-space: none;
      overflow: hidden;
      p {
        text-overflow: ellipsis;
      }
      h1 {
        margin-bottom: 20px;
      }
      .ivu-btn {
        margin-top: 20px;
      }
    }
  }
  line-height: 200px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background: white;
}
.content-wrapper {
  margin: 15px 0;
  .ivu-carousel {
    border-radius: 4px;
  }

  img {
    width: 100%;
  }
}
.company-services {
  margin-top: 15px;
  background-color: #e3e5e8;
  border-radius: 4px;
  .subtitle {
    font-size: 18px;
    margin-top: 20px;
  }
  .ivu-card {
    min-height: 100%;
  }
  .text-services {
    padding-left: 12px;
  }
}
@media screen and (max-width: 768px) {
  .news-col {
    margin-top: 15px;
  }
  .company-services {
    .ivu-card {
      .ivu-menu {
        &::after {
          display: none;
        }
      }
      .text-services {
        margin-top: 20px;
        padding-right: 12px;
      }
    }
  }
}
</style>
